import React from 'react';

const ServerSettings = () => {
    return (
        <div className="dashboard-main">
            <div className="hero-panel">
                <div>
                    <h2 style={{ margin: 0, fontSize: '1.8rem' }}>⚙️ Server-Einstellungen</h2>
                    <p className="muted small">Server-Konfiguration und Einstellungen</p>
                </div>
            </div>
            
            <div className="grid">
                <div className="card">
                    <div className="card-header">
                        <h4>Server-Konfiguration</h4>
                    </div>
                    <div className="card-body">
                        <p className="muted">Hier können Server-Einstellungen und Konfigurationen vorgenommen werden.</p>
                        <div className="coming-soon">
                            <div className="coming-icon">⚙️</div>
                            <h3>Server-Konfiguration</h3>
                            <p className="muted">Dieses Feature ist in Entwicklung und wird bald verfügbar sein.</p>
                        </div>
                    </div>
                </div>
                
                <div className="card">
                    <div className="card-header">
                        <h4>Aktuelle Einstellungen</h4>
                    </div>
                    <div className="card-body">
                        <div className="list">
                            <div className="list-item">
                                <div>
                                    <strong>Server Status</strong>
                                    <p className="muted small">Online</p>
                                </div>
                            </div>
                            <div className="list-item">
                                <div>
                                    <strong>Spieler Limit</strong>
                                    <p className="muted small">64 Slots</p>
                                </div>
                            </div>
                            <div className="list-item">
                                <div>
                                    <strong>Server Region</strong>
                                    <p className="muted small">Europe</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServerSettings;
